<admin-layout pageTitle="Produtores" searchPlaceholder="Nome ou código" [showSearch]="true" (searchChange)="search = $event">
    <entity-cards
        #list
        [repository]="repository"
        [perspective]="perspective"
        [searchTerm]="search"
        [summary]="true"
    >
        <mat-card
            class="entityCard admin-entity-card"
            *entityCard="let entity"
            (click)="openEntity(entity)"
        >
            <div class="card-accent"></div>
            <div class="card-body">
                <div class="info-item code">
                    <span class="info-label">Código</span>
                    <span class="info-value">{{ entity.code }}</span>
                </div>
                <div class="info-item name">
                    <span class="info-label">Nome</span>
                    <span class="info-value" [title]="entity.name">{{ entity.name }}</span>
                </div>
            </div>
            <div class="card-foot">
                <span class="hint">Abrir cadastro</span>
                <mat-icon>chevron_right</mat-icon>
            </div>
        </mat-card>
    </entity-cards>
    <button
        mat-fab
        color="accent"
        class="floatDefault"
        (click)="openFirstAccess()"
        aria-label="Primeiro acesso"
        matTooltip="Primeiro acesso"
    >
        <mat-icon>add</mat-icon>
    </button>
</admin-layout>
